import './ccf-authenticated-voice-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfAuthenticatedVoiceIconProps extends SvgIconProps {}
/**
 * This icon will be used to show voice authentication
 * @param props - CcfAuthenticatedVoiceIconProps
 * @example - <CcfAuthenticatedVoiceIcon />
 * @returns SVG of voice authentication
 */
export function CcfAuthenticatedVoiceIcon(
  props: CcfAuthenticatedVoiceIconProps
) {
  return (
    <SvgIcon viewBox="0 0 34 34" {...props} >
      <g id="RTA_Green" data-name="RTA Green">
        <g id="Layer_5" data-name="Layer 5" transform="translate(2 5)">
          <rect id="Rectangle_1" data-name="Rectangle 1" width="7.348" height="2.999" rx="1.5" transform="translate(2.999 6.598) rotate(90)" fill="#18a670"/>
          <rect id="Rectangle_2" data-name="Rectangle 2" width="7.348" height="2.999" rx="1.5" transform="translate(26.543 6.598) rotate(90)" fill="#18a670"/>
          <rect id="Rectangle_3" data-name="Rectangle 3" width="14.546" height="2.999" rx="1.5" transform="translate(8.998 2.999) rotate(90)" fill="#18a670"/>
          <rect id="Rectangle_4" data-name="Rectangle 4" width="14.546" height="2.999" rx="1.5" transform="translate(20.545 2.999) rotate(90)" fill="#18a670"/>
          <rect id="Rectangle_5" data-name="Rectangle 5" width="20.545" height="2.999" rx="1.5" transform="translate(14.734) rotate(90)" fill="#18a670"/>
          <circle id="Ellipse_1" data-name="Ellipse 1" cx="6.473" cy="6.473" r="6.473" transform="translate(17.021 10.263)" fill="#fff" stroke="#fff" strokeWidth="2"/>
          <path id="Path_11" data-name="Path 11" d="M461.439,283.919a1.4,1.4,0,0,1-.112.1,1.343,1.343,0,0,1-1.794-.089l-2.721-2.72a1.342,1.342,0,0,1,0-1.893h0a1.342,1.342,0,0,1,1.892,0l1.776,1.776,4.355-4.354a1.32,1.32,0,0,1,.247-.195,6.449,6.449,0,1,0,1.9,4.561,6.419,6.419,0,0,0-.425-2.3Z" transform="translate(-436.979 -264.353)" fill="#18a670"/>
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfAuthenticatedVoiceIcon;
